import {isAbsent} from './is';

const
    {hasOwnProperty} = Object.prototype,

    get = (object, ...keys) => {
        for (let key of keys) {
            if (isAbsent(object)) {
                break;
            }
            object = object[key];
        }
        return object;
    },

    set = (object, ...keys) => (
        value => {
            let destination = object || {};
            const
                source = destination,
                last = keys.length - 1;

            for (let i = 0; i < last; i += 1) {
                const key = keys[i];

                destination = destination[key] || (destination[key] = {});
            }
            if (last >= 0) {
                destination[keys[last]] = value;
            }
            return source;
        }),

    keys = Object.keys,

    owns = (object, key) => hasOwnProperty.call(object, key);

export {
    get,
    set,
    keys,
    owns
};
